import { useReducer, useEffect, useCallback, useRef } from 'react';

const INIT_MUTATE = 'INIT_MUTATE';
const MUTATE_SUCCESS = 'MUTATE_SUCCESS';
const MUTATE_FAILURE = 'MUTATE_FAILURE';
const RESET = 'RESET';

const initialState = {
  data: null,
  error: null,
  isMutating: false,
  isSucess: false,
  isError: false,
};

const fetchReducer = (state, action) => {
  const { type, data, error } = action;

  switch (type) {
    case INIT_MUTATE:
      return { ...state, isMutating: true };
    case MUTATE_SUCCESS:
      return { ...state, data, isSucess: true, isMutating: false };
    case MUTATE_FAILURE:
      return { ...state, error, isError: true, isMutating: false };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const useMutation = ({
  mutationFn,
  onSuccess = () => {},
  onError = () => {},
}) => {
  const [state, dispatch] = useReducer(fetchReducer, initialState);
  const fetcherRef = useRef(mutationFn);
  const abortRef = useRef();

  const abort = useCallback(() => {
    if (abortRef.current) abortRef.current.abort();
  }, []);

  useEffect(() => () => abort(), []);

  const mutate = useCallback(
    data => {
      const internalMutate = async () => {
        dispatch({ type: INIT_MUTATE });
        try {
          // eslint-disable-next-line no-undef
          const abortController = new AbortController();
          abortRef.current = abortController;
          const options = { signal: abortController };

          const response = await fetcherRef.current({
            variable: data,
            ...options,
          });
          onSuccess(response);
          dispatch({ type: MUTATE_SUCCESS, data: response });
        } catch (error) {
          onError(error);
          dispatch({ type: MUTATE_SUCCESS, error });
        }
      };

      dispatch({ type: RESET });
      internalMutate();
    },
    [onSuccess],
  );

  return { ...state, mutate, abort };
};

export default useMutation;
